import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { setToken, setUser } from "../../services/authService";
import axios from "../../utils/axiosInstance";

const Login = () => {
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const payload = {
      id: data.get("id"),
      password: data.get("password"),
    };
  
    try {
      const res = await axios.post("/agent/login", payload);
      const { token, success, agent } = res.data;
      if (success) {
        setToken(token);
        setUser(agent);
        navigate("/");
      }
    
    } catch (err) {
      alert("로그인 실패");
      console.error(err);
    }
    navigate('/');
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        backgroundImage: "url('../../login_bg.png')", // 배경 이미지 경로
        backgroundSize: "contain", // 배경 이미지가 화면에 꽉 차도록 설정
        backgroundPosition: "center", // 배경 이미지의 위치 설정
        backgroundRepeat: "no-repeat", // 이미지 반복 제거
        overflow: "hidden",
      }}
    >
    

    <Container component="main" maxWidth="xs">
        {/* 로고 이미지 */}
        <Box
          component="img"
          src="../../logo.png" // 로고 이미지 경로
          alt="로고"
          sx={{
            display: "block",
            width: "200px", // 로고 크기 조정
            height: "auto",
            margin: "0 auto 20px", // 간격 조정
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.85)", // 반투명 배경
            padding: 4,
            borderRadius: 2,
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.3)", // 그림자 효과
          }}
        >
          <Typography
            component="h1"
            variant="h5"
            sx={{
              fontWeight: "bold",
              color: "#4CAF50", // 텍스트 색상
              marginBottom: 2,
            }}
          >
            로그인
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="id"
              label="아이디"
              name="id"
              autoComplete="id"
              autoFocus
              placeholder="아이디"
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.9)", // 입력창 배경색
                borderRadius: "5px",
                outline: "none", // 포커스 시 기본 테두리 제거
                "& .MuiOutlinedInput-root": {
                  "&:focus-within": {
                    outline: "none", // 포커스 시 아웃라인 제거
                  },
                },
              }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="비밀번호"
              type="password"
              id="password"
              placeholder="비밀번호"
              autoComplete="current-password"
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.9)", // 입력창 배경색
                borderRadius: "5px",
                outline: "none", // 포커스 시 기본 테두리 제거
                "& .MuiOutlinedInput-root": {
                  "&:focus-within": {
                    outline: "none", // 포커스 시 아웃라인 제거
                  },
                },
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                backgroundColor: "#4CAF50", // 버튼 색상
                color: "#fff", // 버튼 텍스트 색상
                fontWeight: "bold",
                '&:hover': {
                  backgroundColor: "#45A049", // 호버 색상
                },
              }}
            >
              로그인
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Login;
